import React, { Fragment, Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import Paper from 'material-ui/Paper';
import Menu from 'material-ui/Menu';
import MenuItem from 'material-ui/MenuItem';
import Divider from 'material-ui/Divider';
import AutoComplete from 'material-ui/AutoComplete';
import styles from '@layout/ClientEditPage';
import styled from 'styled-components';
import { Icon, Button } from '@atoms';
import { Whitespace } from '@layout';

const AutocompleteWrapper = styled.div`
  display: flex;
  border: solid 1px #d8d8d8;
  olor: #00819b;
  padding: 0 13px;
  border-radius: 2px;
  margin-right: 50px;

  & hr {
    display: none;
  }
`;

const H4 = styled.h4`
  font-size: 17px;
  font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 0px;
  color: #00819b;
`;

class AnalystSelector extends Component {
  render() {
    const { list, onAdd, onRemove, selectedList, onUpdateInput } = this.props;
    const autoCompleteList = _.differenceWith(list, selectedList, _.isEqual);
    const itemsAreSelected = selectedList.length > 1;

    return (
      <Fragment>
        <AutocompleteWrapper>
          <AutoComplete
            placeholder="Search"
            onUpdateInput={onUpdateInput}
            name="analystSelector"
            fullWidth
            filter={(searchText, key) => true}
            dataSource={autoCompleteList}
            dataSourceConfig={{ text: 'email', value: 'id' }}
            onNewRequest={onAdd}
          />
          <Icon name="magnifyingGlass" style={{ width: '1.5rem' }} />
        </AutocompleteWrapper>
        {selectedList.length ? (
          <Fragment>
            <Whitespace size="1rem" />
            <H4>Emails</H4>
            <Paper style={styles.AnalystSelectorComponent.paper}>
              <Menu
                name="analyst-selector-menu"
                listStyle={styles.AnalystSelectorComponent.listStyle}
              >
                {selectedList.map((item, index) => {
                  const notLastItem = index !== selectedList.length - 1;

                  return (
                    <Fragment key={item.id}>
                      <MenuItem
                        key={`${item.id}_MenuItem`}
                        name={`${item.id}_MenuItem`}
                        style={styles.AnalystSelectorComponent.menuItem}
                        primaryText={item.email}
                        leftIcon={
                          <Button
                            invisible
                            className="remove-analyst"
                            onClick={() => onRemove(item)}
                          >
                            <Icon name="crossGrey" />
                          </Button>
                        }
                      />
                      {itemsAreSelected && notLastItem ? (
                        <Divider key={`${item.id}_Divider`} />
                      ) : null}
                    </Fragment>
                  );
                })}
              </Menu>
            </Paper>
          </Fragment>
        ) : null}
      </Fragment>
    );
  }
}

AnalystSelector.propTypes = {};

export default AnalystSelector;



// WEBPACK FOOTER //
// ./components/molecules/AnalystSelector/AnalystSelector.js